import React, { FC, useReducer, useContext, useEffect } from 'react';
import { PlayerContext } from '.';
import { START_PLAYER, PAUSE_PLAYER, STOP_PLAYER } from '../types';
import { playerInitialValue } from './utils';
import { PlayerReducer } from '.';
import { AuthContext } from '../auth';

type Props = {
  children: React.ReactNode;
};
const PlayerState: FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(PlayerReducer, playerInitialValue);
  const { isAuthenticated } = useContext(AuthContext);

  const startPlayer = () => {
    dispatch({
      type: START_PLAYER,
    });
  };
  const pausePlayer = () => {
    dispatch({
      type: PAUSE_PLAYER,
    });
  };
  const stopPlayer = () => {
    dispatch({
      type: STOP_PLAYER,
    });
  };

  // Stop player when user is logged out
  useEffect(() => {
    if (!isAuthenticated && (state.playerActive || state.playerPaused)) {
      stopPlayer();
    }
  }, [isAuthenticated, state.playerActive, state.playerPaused]);

  return (
    <PlayerContext.Provider
      value={{
        startPlayer,
        pausePlayer,
        stopPlayer,
        playerActive: state.playerActive,
        playerPaused: state.playerPaused,
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
};

export default PlayerState;
